import React, { useState, useEffect, useMemo } from "react";
import { useDispatch,useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  Box,
  Button,
  Typography,
  Divider
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
// Old change: UTC plugin import used by the previous date conversion.
// import utc from "dayjs/plugin/utc";
import { Alert } from "@mui/material";
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
// import { REPORTS } from "../../config/reportConfig";
import { getCollectionDetails, getserviceRevenueReport, getBillSummaryReport, getBillRevenueReport, getCategoryList , getDoctorServiceReport} from "../../core/actions/reportDownloadAction";
import { generateCollectionDetailsExcel , generateBillSummaryExcel,generateBillingBundleExcel, generateServiceRevenueExcel, generateBillRevenueExcel, generateDoctorServiceExcel} from "../../utils/generateInvoiceExcel";
// Old hard-coded department source:
// import { BILLING_LOCATION_NAMES } from "../../core/constants/erpConstants";
// New change: dependencies for organization-aware master-location loading.
import { ORG_CODES } from "../../shared/constants";
import { useOrganization } from "../../configurations/OrganizationContext";
import { getAllMasterLocationDetails } from "../erp-billing/ERPActions/erpActions";
import doctorActions from "../../core/actions/doctorActions";
import { getPatientJourneyReport } from "../../core/actions/reportDownloadAction";
import { generatePatientJourneyExcel } from "../../utils/generateInvoiceExcel";
import { getPatientVisitSummaryReport } from "../../core/actions/reportDownloadAction";
import { generatePatientVisitSummaryExcel } from "../../utils/generateInvoiceExcel";
/* -------------------- Filter Components -------------------- */
// Old change: enabled the UTC conversion used by the previous payload.
// dayjs.extend(utc);

// src/config/reportConfig.js
export const REPORTS = [
  {
    key: "cashCollection",
    label: "Cash Collection Report",

    filters: {
      dateRange: true,
      person: true,
    },

    buildPayload: ({ dateRange, selectedPerson }) => ({
      person: selectedPerson === "ALL" ? null : selectedPerson,
      startdate: dateRange.start,
      enddate: dateRange.end
    })
  },

  {
    key: "billsummary",
    label: "Bill Summary Report",

    filters: {
      dateRange: true,
      type: true,
      department: true
    },
    buildPayload: ({ dateRange, selectedDepartment, selectedType }) => ({
    fromDate: dayjs(dateRange.start)
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss"),

    toDate: dayjs(dateRange.end)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss"),
      department: selectedDepartment,
      typeFilter: selectedType,
      reportType: "BillingSummary"
    })
  },

  {
    key: "billrevenue",
    label: "Bill Revenue Report",

    filters: {
      dateRange: true,
      type: true,
      department: true
    },
    buildPayload: ({ dateRange, selectedDepartment, selectedType }) => ({
    fromDate: dayjs(dateRange.start)
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss"),

    toDate: dayjs(dateRange.end)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss"),
      department: selectedDepartment,
      typeFilter: selectedType,
      reportType: "BillingRevenue"
    })
  },

   {
    key: "serviceRevenue",
    label: "Service Revenue Report",

    filters: {
      dateRange: true,
      category: true,
      type: true
    },

    buildPayload: ({ dateRange, selectedCategory, selectedType }) => ({
    fromDate: dayjs(dateRange.start)
        .startOf("day")
        .format("YYYY-MM-DDTHH:mm:ss"),

    toDate: dayjs(dateRange.end)
        .endOf("day")
        .format("YYYY-MM-DDTHH:mm:ss"),
      categoryFilter: selectedCategory,
      typeFilter: selectedType,
      reportType: "ServiceRevenue"
    })
  },

  //   {
  //   key: "doctorReport",
  //   label: "Doctor Report",

  //   filters: {
  //     dateRange: true,
  //     department: true
  //   },
  //   buildPayload: ({ dateRange, selectedDepartment }) => ({
  //   fromDate: dayjs(dateRange.start)
  //       .startOf("day")
  //       .format("YYYY-MM-DDTHH:mm:ss"),

  //   toDate: dayjs(dateRange.end)
  //       .endOf("day")
  //       .format("YYYY-MM-DDTHH:mm:ss"),
  //     department: selectedDepartment,
  //     reportType: "doctorReport"
  //   })
  // }

{
  key: "doctorReport",
  label: "Doctor Report",

  filters: {
    year: true,
    department: true
  },

  buildPayload: ({ selectedYear, selectedDepartment }) => ({
    fromDate: dayjs(`${selectedYear}-01-01`)
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss"),

    toDate: dayjs(`${selectedYear}-12-31`)
      .endOf("day")
      .format("YYYY-MM-DDTHH:mm:ss"),

    department: selectedDepartment,
    reportType: "doctorReport"
  })
},
{
  key: "patientJourney",
  label: "Patient Visit Journey Report",
  filters: {
    dateRange: true,
  },
  buildPayload: ({ dateRange }) => ({
    fromDate: dayjs(dateRange.start).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    toDate: dayjs(dateRange.end).endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
    reportType: "patientJourney"
  })
},


];


const DateRangeFilter = ({ value, onChange }) => (
  <Box mb={2}>
    <Typography fontSize={13} mb={0.5}>
      Date Range
    </Typography>
    <Box display="flex" gap={1}>
      <input
        type="date"
        className="form-control"
        value={value.start}
        onChange={(e) =>
          onChange({ ...value, start: e.target.value })
        }
      />
      <input
        type="date"
        className="form-control"
        value={value.end}
        onChange={(e) =>
          onChange({ ...value, end: e.target.value })
        }
      />
    </Box>
  </Box>
);

// const PersonFilter = ({ value, onChange }) => (
//   <Box mb={2}>
//     <Typography fontSize={13} mb={0.5}>
//       Person
//     </Typography>
//     <select
//       className="form-select"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//     >
//       <option value="ALL">All</option>
//       {/* later: map staff list */}
//     </select>
//   </Box>
// );


const PersonFilter = ({ value, onChange, staffList = [] }) => (
  <Box mb={2}>
    <Typography fontSize={13} mb={0.5}>Person</Typography>

    <select
      className="form-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="ALL">All</option>

      {staffList.map((p) => (
        <option key={p.userId} value={p.userId}>
          {p.first_name}
        </option>
      ))}
    </select>
  </Box>
);


// const LocationFilter = ({ value, onChange, locations }) => (
//   <Box mb={2}>
//     <Typography fontSize={13} mb={0.5}>
//       Locations
//     </Typography>

//     <select
//       className="form-select"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//     >
//       <option value="ALL">All</option>

//       {locations?.map((loc) => (
//         <option key={loc.locationKey} value={loc.locationKey}>
//           {loc.displayName}
//         </option>
//       ))}
//     </select>
//   </Box>
// );


const LocationFilter = ({ value, onChange, locations = [] }) => (
  <Box mb={2}>
    <Typography fontSize={13} mb={0.5}>
      Locations
    </Typography>

    <select
      className="form-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="ALL">All</option>

      {Array.isArray(locations) &&
        locations.map((loc) => (
          <option key={loc.locationKey} value={loc.locationKey}>
            {loc.displayName}
          </option>
        ))}
    </select>
  </Box>
);


// const CategoryFilter = ({ value, onChange }) => (
//   <Box mb={2}>
//     <Typography fontSize={13} mb={0.5}>Category</Typography>
//     <select
//       className="form-select"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//     >
//       <option value="ALL">All</option>
//     </select>
//   </Box>
// );


const CategoryFilter = ({ value, onChange, categoryList = [] }) => (
  <Box mb={2}>
    <Typography fontSize={13} mb={0.5}>Category</Typography>

    <select
      className="form-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="ALL">All</option>

      {categoryList
        .filter(cat => cat !== "ALL")
        .map((cat) => (
          <option key={cat} value={cat}>
            {cat}
          </option>
        ))}
    </select>
  </Box>
);


// Old change: hard-coded DepartmentFilter implementation.
// const DepartmentFilter = ({ value, onChange, locations = [] }) => (
//   <Box mb={2}>
//     <Typography fontSize={13} mb={0.5}>Department</Typography>
//     <select
//       className="form-select"
//       value={value}
//       onChange={(e) => onChange(e.target.value)}
//     >
//       <option value="ALL">All</option>
//       {Object.values(BILLING_LOCATION_NAMES).map((dept) => (
//         <option key={dept} value={dept}>
//           {dept}
//         </option>
//       ))}
//
//       {/* {Array.isArray(locations) &&
//       locations.map((loc) => (
//         <option key={loc.locationKey} value={loc.locationKey}>
//           {loc.displayName}
//         </option>
//       ))} */}
//     </select>
//   </Box>
// );

// New change: master-location-based DepartmentFilter implementation.
const DepartmentFilter = ({
  value,
  onChange,
  locations = []
}) => (
  <Box mb={2}>
    <Typography fontSize={13} mb={0.5}>Department</Typography>
    <select
      className="form-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="ALL">All</option>
      {locations.map((location) => {
        const erpName =
          location.locationDetails?.erpLocationDetails?.[0]?.name ||
          location.displayName;
        const servicesAllowed = location.servicesAllowed || [];
        const reportName =
          servicesAllowed.length === 1 ? servicesAllowed[0] : erpName;

        return (
          <option key={location.locationKey} value={reportName}>
            {location.displayName || erpName}
          </option>
        );
      })}
    </select>
  </Box>
);


const DoctorDepartmentFilter = ({ value, onChange, departmentList = [] }) => (
  <Box mb={2}>
    <Typography fontSize={13} mb={0.5}>
      Doctor Department
    </Typography>

    <select
      className="form-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="ALL">All</option>

      {departmentList.map((dept) => (
        <option key={dept} value={dept}>
          {dept}
        </option>
      ))}
    </select>
  </Box>
);



const YearFilter = ({ value, onChange }) => (
  <Box mb={2}>
    <Typography fontSize={13} mb={0.5}>
      Year
    </Typography>

    <select
      className="form-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {Array.from({ length: 6 }).map((_, i) => {
        const yr = dayjs().year() - i;
        return (
          <option key={yr} value={yr}>
            {yr}
          </option>
        );
      })}
    </select>
  </Box>
);




const TypeFilter = ({ value, onChange }) => (
  <Box mb={2}>
    <Typography fontSize={13} mb={0.5}>Type</Typography>
    <select
      className="form-select"
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="ALL">All</option>
      <option value="InPatient">InPatient</option>
      <option value="OutPatient">OutPatient</option>
    </select>
  </Box>
);


/* -------------------- Main Component -------------------- */

export default function DownloadReportActions() {
  const dispatch = useDispatch();
  // New change: organization is required for Vedamaayu location filtering.
  const org = useOrganization();
  const allMasterLocationDetails = useSelector(
    (state) => state.erpDetailsState?.masterLocationDetails
  );
  const today = dayjs().format("YYYY-MM-DD");
  const [selectedLocation, setSelectedLocation] = React.useState("ALL");
  const [selectedReport, setSelectedReport] = React.useState(
    REPORTS[0].key
  );
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [dateRange, setDateRange] = React.useState({
    start: today,
    end: today
  });
  const [selectedYear, setSelectedYear] = useState(dayjs().year());
  const [doctorDepartmentList, setDoctorDepartmentList] = useState([]);
  const [selectedPerson, setSelectedPerson] = React.useState("ALL");
  const [selectedCategory, setSelectedCategory] = useState("ALL");
  const [selectedDepartment, setselectedDepartment] = useState("ALL");
  const [selectedType, setSelectedType] = useState("ALL");
  
  // New states for cash collection department filter
  const [cashCollectionDepartment, setCashCollectionDepartment] = useState("");
  const COLLECTION_ALLOWED_TYPES = ["registrationdesk"];
  
  const activeReport = REPORTS.find(
    (r) => r.key === selectedReport
  );

  const locationsArray = Array.isArray(allMasterLocationDetails)
  ? allMasterLocationDetails
  : allMasterLocationDetails
  ? Object.values(allMasterLocationDetails)
  : [];

  // New change: derive report departments from master-location configuration.
  const reportLocations = locationsArray.filter((location) => {
    const isBillingLocation =
      location.locationDetails?.erpLocationDetails?.some(
        (detail) => detail.isBillingLocation
      );
    const servicesAllowed = (location.servicesAllowed || []).map((service) =>
      service.toUpperCase()
    );

    if (org?.orgCode?.toLowerCase() === ORG_CODES.VEDAMAAYU) {
      return (
        isBillingLocation &&
        (servicesAllowed.includes("HMS") ||
          servicesAllowed.includes("PHARMACY"))
      );
    }

    return isBillingLocation;
  });

  const [categoryList, setCategoryList] = useState([]);
  const [staffList, setStaffList] = useState([]);
  
  // Get department list from staff for cash collection
  const departmentList = useMemo(() => {
    return [
      ...new Set(
        staffList
          .filter(
            (person) =>
              person.type &&
              COLLECTION_ALLOWED_TYPES.includes(
                person.type.toLowerCase()
              )
          )
          .map((person) => person.type.toLowerCase())
      ),
    ];
  }, [staffList]);

  // Helper function to get users by department
  const getUsersByDepartment = (department) => {
    if (!department) return [];
    return staffList
      .filter(
        (person) =>
          person.type &&
          person.type.toLowerCase() === department.toLowerCase()
      )
      .map((person) => person.userId);
  };
  
  // New change: load master locations when a report needs a department filter.
  const hasDepartmentFilter = Boolean(activeReport?.filters.department);
  useEffect(() => {
    if (hasDepartmentFilter && locationsArray.length === 0) {
      getAllMasterLocationDetails(dispatch).catch((error) =>
        console.error("Unable to load report locations:", error)
      );
    }
  }, [dispatch, hasDepartmentFilter, locationsArray.length]);

  useEffect(() => {
    if (activeReport?.key === "doctorReport" && doctorDepartmentList.length === 0) {
      getDocDepartmentList();
    }

    // Staff list needed ONLY for Cash Collection
    if (
      activeReport?.key === "cashCollection" &&
      staffList.length === 0
    ) {
      fetchStaffList();
    }

    // Category list needed ONLY for Service Revenue
    if (
      activeReport?.key === "serviceRevenue" &&
      categoryList.length === 0
    ) {
      fetchCategoryList();
    }
    
    // Reset cash collection department when changing reports
    if (activeReport?.key !== "cashCollection") {
      setCashCollectionDepartment("");
    }
  }, [activeReport?.key]);

  // Reset department when person changes from ALL to specific person
  useEffect(() => {
    if (activeReport?.key === "cashCollection" && selectedPerson !== "ALL") {
      setCashCollectionDepartment("");
    }
  }, [selectedPerson, activeReport?.key]);


const fetchCategoryList = () => {
  dispatch(
    getCategoryList({}, (resCb) => {
      if (resCb?.categoryList) {
        console.log("categoryList:::::", resCb.categoryList);
        setCategoryList(resCb.categoryList);
      }
    })
  );
};

const fetchStaffList = () => {
  dispatch(
    doctorActions.getStaffList((resCb) => {
      if (resCb?.accresp?.personList) {
        const staffOnly = resCb.accresp.personList.filter(
          (p) => String(p.type).toLowerCase() !== "doctor"
        );

        setStaffList(staffOnly);

        // const loggedInUserId = JSON.parse(
        //   localStorage.getItem("userId")
        // );

        // const matchedUser = staffOnly.find(
        //   (p) => p.userId === loggedInUserId
        // );

        // if (matchedUser) {
        //   setSelectedPerson(matchedUser.userId);
        // }
      }
    })
  );
};


const getDocDepartmentList = () => {
  dispatch(
    doctorActions.getDepartmentList({}, (resCb) => {
      if (Array.isArray(resCb)) {
        const namesOnly = resCb.map(d => d.name);
        setDoctorDepartmentList(namesOnly);
      }
    })
  );
};



//   const payload = activeReport.buildPayload({
//     dateRange: {
//         start: dayjs(dateRange.start).startOf("day").utc(true).toISOString(),
//         end: dayjs(dateRange.end).endOf("day").utc(true).toISOString(),
//     },
//     selectedPerson,
//     selectedCategory,
//     selectedType,
//   });

//   const handleDownload = () => {
//     if (key === "cashCollection"){
//     const payload = activeReport.buildPayload({
//     dateRange: {
//         start: dayjs(dateRange.start)
//         .startOf("day")
//         .utc(true)
//         .toISOString(),

//         end: dayjs(dateRange.end)
//         .endOf("day")
//         .utc(true)
//         .toISOString(),
//     },
//     selectedPerson
//     });

//    console.log("DateRange:", dateRange);

//     dispatch(
//       getCollectionDetails(payload, async (res) => {
//         const rows = res?.erpResp?.customerPaymentInfo || [];
    
//         if (!rows.length) {
//             setServerRes({ success: "", error: "No data available" });
//             return;
//         }

//         const buffer = await generateCollectionDetailsExcel(rows);
//         const blob = new Blob([buffer], {
//           type:
//             "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//         });

//         const link = document.createElement("a");
//         link.href = URL.createObjectURL(blob);
//         link.download = `${activeReport.key}_${Date.now()}.xlsx`;
//         link.click();
//       })
//     );
//    } else if (key === "serviceRevenue"){
//         const payload = activeReport.buildPayload({
//     dateRange: {
//         start: dayjs(dateRange.start)
//         .startOf("day")
//         .utc(true)
//         .toISOString(),

//         end: dayjs(dateRange.end)
//         .endOf("day")
//         .utc(true)
//         .toISOString(),
//     },
//     categoryFilter : "ALL",
//     typeFilter : "ALL",
//     reportType : "ServiceRevenue"
//     });

//    console.log("DateRange:", dateRange);

//     dispatch(
//       getserviceRevenueReport(payload, async (res) => {
//         const rows = res?.erpResp?.customerPaymentInfo || [];
    
//         if (!rows.length) {
//             setServerRes({ success: "", error: "No data available" });
//             return;
//         }

//         const buffer = await generateCollectionDetailsExcel(rows);
//         const blob = new Blob([buffer], {
//           type:
//             "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//         });

//         const link = document.createElement("a");
//         link.href = URL.createObjectURL(blob);
//         link.download = `${activeReport.key}_${Date.now()}.xlsx`;
//         link.click();
//       })
//     );
//    }
//   };


const handleDownload = () => {
  if (!activeReport) return;

  // Special handling for cash collection
  if (activeReport.key === "cashCollection") {
    let usersToSend = [];
    
    // Validation
    if (selectedPerson === "ALL" && !cashCollectionDepartment) {
      showServerMessage("error", "Please select a department");
      return;
    }

    if (selectedPerson === "ALL") {
      if (cashCollectionDepartment) {
        usersToSend = getUsersByDepartment(cashCollectionDepartment);
        if (usersToSend.length === 0) {
          showServerMessage("error", "No users found for selected department");
          return;
        }
      } else {
        showServerMessage("error", "Please select a specific department");
        return;
      }
    } else {
      usersToSend = [selectedPerson];
    }

    const payload = {
      person: usersToSend,
      startdate: dayjs(dateRange.start).toISOString(),
      enddate: dayjs(dateRange.end).toISOString(),
    };

    dispatch(
      getCollectionDetails(payload, async (res) => {
        const rows = res?.erpResp?.customerPaymentInfo || [];

        if (!rows.length) {
          showServerMessage("error", "No data available");
          return;
        }

        const buffer = await generateCollectionDetailsExcel(res?.erpResp);
        downloadExcel(buffer, "cash_Collection");
      })
    );
    return;
  }

  // Build payload ONLY from what the report needs
  // Old change: date range was converted to UTC, which could shift the date.
  // dateRange: {
  //   start: dayjs(dateRange.start)
  //     .startOf("day")
  //     .utc(true)
  //     .toISOString(),
  //   end: dayjs(dateRange.end)
  //     .endOf("day")
  //     .utc(true)
  //     .toISOString(),
  //   /* start: dateRange.start,
  //      end: dateRange.end, */
  // },
  // New change: use plain selected dates to prevent UTC date shifting.
  const payload = activeReport.buildPayload({
    dateRange,
    selectedPerson,
    selectedCategory,
    selectedType,
    selectedDepartment,
    selectedYear
  });

if (activeReport.key === "cashCollection") {

  dispatch(
    getCollectionDetails(payload, async (res) => {
      const rows = res?.erpResp?.customerPaymentInfo || [];
      if (!rows.length) {
        showServerMessage("error", "No data available");
        return;
      }
      const buffer = await generateCollectionDetailsExcel(rows);
      downloadExcel(buffer, "cash_Collection");
    })
  );
}
  // SERVICE REVENUE
  if (activeReport.key === "serviceRevenue") {
    dispatch(
      getserviceRevenueReport(payload, async (res) => {
        const rows = res?.serviceRevenueReport || [];

        if (!rows.length) {
          showServerMessage("error", "No data available");
          return;
        }

        // downloadExcel(rows, activeReport.key);
        const buffer = await generateServiceRevenueExcel(rows);
        downloadExcel(buffer, "service_revenue");
      })
    );
  }

    // BILL REVENUE
 if (activeReport.key === "billrevenue") {
  dispatch(
    getBillRevenueReport(payload, async (res) => {
    
      // Old change:
      // const rows = res?.erpResp?.BillRevenueReportDTOList || [];
      // New change: support both Hospital and ERP response-property casing.
      const rows =
        res?.erpResp?.BillRevenueReportDTOList ||
        res?.erpResp?.billRevenueReportDTOList ||
        [];

      if (!rows.length) {
        showServerMessage("error", "No data available");
        return;
      }

      const buffer = await generateBillRevenueExcel(rows, {
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        department: payload.department,
        // Old change:
        // type: payload.type,
        // New change: use the actual type filter in the Excel heading.
        type: payload.typeFilter,
      });

      downloadExcel(buffer, "bill_revenue");
    })
  );
}
  // BILL SUMMARY
  // if (activeReport.key === "billsummary") {
  //   dispatch(
  //     getBillSummaryReport(payload, async (res) => {
  //       const rows = res?.billSummaryReport || [];

  //       if (!rows.length) {
  //         setServerRes({ success: "", error: "No data available" });
  //         return;
  //       }

  //       // downloadExcel(rows, activeReport.key);
  //       const buffer = await generateBillSummaryExcel(rows);
  //       downloadExcel(buffer, "bill_summary");
  //     })
  //   );
  // }

  if (activeReport.key === "billsummary") {
  dispatch(
    getBillSummaryReport(payload, async (res) => {
      const billRows = res?.billSummaryReport || [];
      const advanceRows = res?.advanceReport || [];
      const refundRows = res?.refundReport || [];

      if (!billRows.length && !advanceRows.length && !refundRows.length) {
        showServerMessage("error", "No data available");
        return;
      }

      const buffer = await generateBillingBundleExcel({
        billRows,
        advanceRows,
        refundRows,
      });

      downloadExcel(buffer, "billing_summary");
    })
  );
}

//DOCTOR REPORT
 if (activeReport.key === "doctorReport") {
  dispatch(
    getDoctorServiceReport(payload, async (res) => {
      const rows = res?.doctorServiceList || [];

      if (!rows.length) {
        showServerMessage("error", "No data available");
        return;
      }

      const buffer = await generateDoctorServiceExcel(rows, {
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        department: payload.department
      });

      downloadExcel(buffer, "Doctor_Report");
    })
  );
}

if (activeReport.key === "patientJourney") {
  dispatch(
    getPatientJourneyReport(payload, async (res) => {
      const rows = res?.patientJourneyList || [];

      if (!rows.length) {
        showServerMessage("error", "No data available");
        return;
      }

      const groupedRows = rows.map(patient => ({
        ...patient,
        visits: patient.visits || []
      }));

      const buffer = await generatePatientJourneyExcel(groupedRows);
      downloadExcel(buffer, "patient_journey");
    })
  );
}

};


const downloadExcel = async (buffer, name) => {
//   const buffer = await generateCollectionDetailsExcel(rows);
  const blob = new Blob([buffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${name}_${Date.now()}.xlsx`;
  link.click();
};



  const closeAlert = () => {
   setServerRes({ success: "", error: "" });    
  };

  const showServerMessage = (type, message, autoClose = true) => {
  setServerRes({ success: "", error: "" });

  setServerRes({
    success: type === "success" ? message : "",
    error: type === "error" ? message : "",
  });

  if (autoClose) {
    setTimeout(() => {
      closeAlert();
    }, 3000); 
  }
};


  return (
    <>
    <div className="m-2">
            {ServerRes.success && (
              <Alert severity="success" className="alert-div">
                {ServerRes.success}{" "}
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={(event) => closeAlert(event)}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              </Alert>
            )}
            {ServerRes.error && (
              <Alert severity="error" className="alert-div">
                {ServerRes.error}{" "}
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={(event) => closeAlert(event)}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              </Alert>
            )}
          </div>
    <Box display="flex" gap={2}>
      {/* LEFT: REPORT LIST */}
      <Box width={320} className="card shadow-sm">
        <Box p={2}>
          <Typography fontWeight={600} mb={1}>
            Reports
          </Typography>

          {REPORTS.map((r) => (
            <Box
              key={r.key}
              onClick={() => setSelectedReport(r.key)}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              px={2}
              py={1}
              mb={1}
              borderRadius={1}
              sx={{
                cursor: "pointer",
                bgcolor:
                  selectedReport === r.key
                    ? "primary.main"
                    : "grey.100",
                color:
                  selectedReport === r.key
                    ? "white"
                    : "text.primary",
                "&:hover": {
                  bgcolor:
                    selectedReport === r.key
                      ? "primary.dark"
                      : "grey.200"
                }
              }}
            >
              <Typography fontSize={14}>
                {r.label}
              </Typography>
              <DownloadIcon fontSize="small" />
            </Box>
          ))}
        </Box>
      </Box>

      {/* RIGHT: FILTERS */}
      <Box className="card shadow-sm flex-grow-1">
        <Box p={2}>
          <Typography fontWeight={600} mb={1}>
            Filters
          </Typography>

          <Divider sx={{ mb: 2 }} />

          {activeReport.filters.dateRange && (
            <DateRangeFilter
              value={dateRange}
              onChange={setDateRange}
            />
          )}

          {/* {activeReport.filters.person && (
            <PersonFilter
              value={selectedPerson}
              onChange={setSelectedPerson}
            />
          )} */}

          {activeReport.filters.person && (
            <PersonFilter
              value={selectedPerson}
              onChange={setSelectedPerson}
              staffList={staffList}
            />
          )}

          {/* Department dropdown for cash collection when "ALL" is selected */}
          {activeReport.key === "cashCollection" && selectedPerson === "ALL" && (
            <Box mb={2}>
              <Typography fontSize={13} mb={0.5}>
                Department
              </Typography>
              <select
                className="form-select"
                value={cashCollectionDepartment}
                onChange={(e) => setCashCollectionDepartment(e.target.value)}
              >
                <option value="">Select Department</option>
                {departmentList.map((dept) => (
                  <option key={dept} value={dept}>
                    {dept.charAt(0).toUpperCase() + dept.slice(1)}
                  </option>
                ))}
              </select>
            </Box>
          )}

         {activeReport.filters.category && (
          <CategoryFilter
            value={selectedCategory}
            onChange={setSelectedCategory}
            categoryList={categoryList}
          />
        )}


          {/* {activeReport.filters.department && (
            <DepartmentFilter
                value={selectedDepartment}
                onChange={setselectedDepartment}
            />
           )} */}

          {activeReport.filters.year && (
            <YearFilter
              value={selectedYear}
              onChange={setSelectedYear}
            />
          )}


           {activeReport.key === "doctorReport" && (
              <DoctorDepartmentFilter
                value={selectedDepartment}
                onChange={setselectedDepartment}
                departmentList={doctorDepartmentList}
              />
            )}

            {activeReport.key !== "doctorReport" &&
              activeReport.filters.department && (
                /* New change: supply DepartmentFilter with master-location data. */
                <DepartmentFilter
                  value={selectedDepartment}
                  onChange={setselectedDepartment}
                  locations={reportLocations}
                />
            )}


           {activeReport.filters.type && (
            <TypeFilter
                value={selectedType}
                onChange={setSelectedType}
            />
           )}

            {activeReport.filters.location && (
            <LocationFilter
              value={selectedLocation}
              onChange={setSelectedLocation}
              locations={locationsArray}
            />
          )}


          {!Object.keys(activeReport.filters).length && (
            <Typography
              fontSize={13}
              color="text.secondary"
            >
              No filters required for this report.
            </Typography>
          )}

          <Box textAlign="right" mt={3}>
            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              onClick={handleDownload}
            >
              Download
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
    </>
  );
}
